import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import axios from "axios";
import VueAxios from "vue-axios";
import md5 from "js-md5";

import rule from "./utils/rule";
import myMixin1 from "./mixins/ShowAlert";
import myMixin2 from "./mixins/ShowDialog";
import share from "./mixins/Share";
import SignLog from "./components/SignLog.vue";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.prototype.$md5 = md5;
Vue.prototype.$rule = rule;
Vue.component("SignLog", SignLog);

Vue.mixin(myMixin1);
Vue.mixin(myMixin2);
Vue.mixin(share);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
